import {css, Icon, Tooltip, view} from '@sail/ui/deprecated';
import {warning} from '@sail/icons/react/Icon';
import {ChatButtonOption, Option} from './ChatButtonOption';

export type Props = {
  options: Option[];
  selectedOptionId?: string;
  disabled?: boolean;
  error?: React.ReactNode;
  animated?: boolean;
};

const ErrorMessage = ({children}: {children: React.ReactNode}): JSX.Element => {
  return (
    <Tooltip
      placement="left"
      delay={0}
      trigger={
        <Icon
          icon={warning}
          aria-label="warning"
          color="red"
          data-testid="error-tooltip-icon"
        />
      }
    >
      {children}
    </Tooltip>
  );
};

export const ChatButtonOptions = ({
  options,
  selectedOptionId,
  disabled,
  error,
  animated,
}: Props) => {
  const buttons = options.map((option) => (
    <ChatButtonOption
      key={`button-option-${option.value}`}
      selected={option.value === selectedOptionId}
      disabled={!!selectedOptionId}
      hidden={!!selectedOptionId && option.value !== selectedOptionId}
      option={option}
      animated={animated}
      onPress={() => {
        if (option.onPress) {
          option.onPress();
        }
      }}
    />
  ));

  return (
    <view.div
      data-testid="button-options-container"
      className="button-options-container"
      css={{
        stack: 'y',
        justifyContent: css.value('flex-end'),
        alignItems: css.value('flex-end'),
        gap: 'small',
      }}
    >
      {disabled && !selectedOptionId ? null : buttons}
      {error ? <ErrorMessage>{error}</ErrorMessage> : null}
    </view.div>
  );
};
